import type { Business } from "@/types/directory";

/**
 * Extra demo listings (part 2) seeded to make each district and taluk feel full.
 * Covers Kundapura, Karkala and the North Canara towns.
 */
export const businessesPartF: Business[] = [
  {
    id: "biz-47",
    slug: "manipal-cafe-aroma",
    name: "Manipal Cafe Aroma",
    tagline: "Coffee, bites and a relaxed corner in Manipal",
    description:
      "A cheerful cafe in Manipal serving freshly brewed coffee, cold brews, sandwiches and desserts, with free Wi-Fi and a bright study-friendly atmosphere for students.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "udupi",
    locationSlug: "manipal",
    address: "AB Road, Manipal, Udupi District - 576104",
    phone: "+91 820 257 1122",
    whatsapp: "+91 96860 71122",
    email: "hello@manipalcafearoma.in",
    website: "https://manipalcafearoma.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Manipal%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20cafe%20interior%20with%20wooden%20furniture%2C%20hanging%20plants%20and%20coffee%20bar%20under%20warm%20pendant%20lighting%2C%20inviting%20cafe%20photography&width=1200&height=800&seq=cbc-biz-manipal-cafe-aroma-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 224,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 6,
    hours: [
      { day: "Monday", open: "08:00", close: "23:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "23:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "23:00", closed: false },
      { day: "Thursday", open: "08:00", close: "23:00", closed: false },
      { day: "Friday", open: "08:00", close: "23:30", closed: false },
      { day: "Saturday", open: "08:00", close: "23:30", closed: false },
      { day: "Sunday", open: "08:00", close: "23:00", closed: false },
    ],
    services: ["Coffee & Cold Brews", "Sandwiches", "Desserts", "Free Wi-Fi"],
    tags: ["Wi-Fi", "Student Friendly", "Cosy", "Takeaway"],
    reviews: [],
  },
  {
    id: "biz-48",
    slug: "kundapura-fish-land",
    name: "Kundapura Fish Land",
    tagline: "Fresh coastal seafood, cooked the traditional way",
    description:
      "A lively seafood restaurant in Kundapura serving fresh fish thalis, prawn ghee roast, neer dosa and Mangalorean curries with generous portions and quick service.",
    categorySlug: "restaurants",
    subcategory: "Seafood Restaurants",
    districtSlug: "udupi",
    locationSlug: "kundapura",
    address: "Harbour Road, Kundapura, Udupi District - 576201",
    phone: "+91 8254 231 440",
    whatsapp: "+91 97314 31440",
    email: "hello@kundapurafishland.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Kundapura%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Authentic%20Mangalorean%20seafood%20platter%20with%20fried%20fish%20and%20prawn%20curry%20on%20a%20banana%20leaf%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-kundapura-fishland-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 286,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 14,
    hours: [
      { day: "Monday", open: "11:30", close: "22:30", closed: false },
      { day: "Tuesday", open: "11:30", close: "22:30", closed: false },
      { day: "Wednesday", open: "11:30", close: "22:30", closed: false },
      { day: "Thursday", open: "11:30", close: "22:30", closed: false },
      { day: "Friday", open: "11:30", close: "23:00", closed: false },
      { day: "Saturday", open: "11:30", close: "23:00", closed: false },
      { day: "Sunday", open: "11:30", close: "22:30", closed: false },
    ],
    services: ["Fresh Seafood", "Fish Thali", "Mangalorean Curries", "Takeaway"],
    tags: ["Fresh Catch", "Neer Dosa", "Coastal Special", "Family Dining"],
    reviews: [],
  },
  {
    id: "biz-49",
    slug: "kundapura-beach-homestay",
    name: "Kundapura Beach Homestay",
    tagline: "Quiet coastal stay near the backwaters",
    description:
      "A peaceful beachside homestay in Kundapura offering clean rooms, home-cooked coastal meals and easy access to the beach, backwaters and lighthouse.",
    categorySlug: "hotels",
    subcategory: "Homestays",
    districtSlug: "udupi",
    locationSlug: "kundapura",
    address: "Beach Road, Kundapura, Udupi District - 576201",
    phone: "+91 8254 232 990",
    whatsapp: "+91 97405 32990",
    email: "stay@kundapurahomestay.in",
    website: "https://kundapurahomestay.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Kundapura%20Beach%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20coastal%20homestay%20with%20palm%20trees%2C%20garden%20seating%20and%20warm%20evening%20light%2C%20welcoming%20beach%20stay%20photography&width=1200&height=800&seq=cbc-biz-kundapura-homestay-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 126,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 5,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Beach Side Rooms", "Home-Cooked Meals", "Backwater Trips", "Parking"],
    tags: ["Near Beach", "Home Food", "Peaceful", "Family Friendly"],
    reviews: [],
  },
  {
    id: "biz-50",
    slug: "kundapura-agri-traders",
    name: "Kundapura Agri Traders",
    tagline: "Seeds, fertilisers and farm supplies for the coast",
    description:
      "A trusted agricultural supply store in Kundapura stocking seeds, fertilisers, pesticides and farm tools, with guidance for areca, coconut and paddy growers.",
    categorySlug: "supermarkets",
    subcategory: "Provision Stores",
    districtSlug: "udupi",
    locationSlug: "kundapura",
    address: "Market Road, Kundapura, Udupi District - 576201",
    phone: "+91 8254 230 660",
    whatsapp: "+91 94497 30660",
    email: "sales@kundapuraagri.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Kundapura%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Organised%20agricultural%20supply%20store%20with%20sacks%20of%20seeds%2C%20fertilisers%20and%20farm%20tools%20on%20shelves%2C%20bright%20daylight%2C%20agri%20retail%20photography&width=1200&height=800&seq=cbc-biz-kundapura-agri-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.2,
    reviewCount: 68,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 19,
    hours: [
      { day: "Monday", open: "08:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "20:00", closed: false },
      { day: "Thursday", open: "08:00", close: "20:00", closed: false },
      { day: "Friday", open: "08:00", close: "20:00", closed: false },
      { day: "Saturday", open: "08:00", close: "20:30", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Seeds", "Fertilisers", "Farm Tools", "Crop Guidance"],
    tags: ["Farm Supplies", "Expert Guidance", "Trusted", "Local"],
    reviews: [],
  },
  {
    id: "biz-51",
    slug: "karkala-heritage-cafe",
    name: "Karkala Heritage Cafe",
    tagline: "Coffee and local flavours near the Gomateshwara statue",
    description:
      "A charming cafe in Karkala serving filter coffee, breakfast specials, sandwiches and local snacks, with cosy seating ideal for visitors exploring the town.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "udupi",
    locationSlug: "karkala",
    address: "Gomateshwara Road, Karkala, Udupi District - 574104",
    phone: "+91 8258 231 770",
    whatsapp: "+91 96866 31770",
    email: "hello@karkalaheritagecafe.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Karkala%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Charming%20cafe%20interior%20with%20rustic%20wooden%20tables%2C%20warm%20pendant%20lighting%20and%20a%20coffee%20counter%2C%20cosy%20inviting%20cafe%20photography&width=1200&height=800&seq=cbc-biz-karkala-heritagecafe-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 132,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 6,
    hours: [
      { day: "Monday", open: "08:00", close: "22:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "22:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "22:00", closed: false },
      { day: "Thursday", open: "08:00", close: "22:00", closed: false },
      { day: "Friday", open: "08:00", close: "22:30", closed: false },
      { day: "Saturday", open: "08:00", close: "22:30", closed: false },
      { day: "Sunday", open: "08:00", close: "22:00", closed: false },
    ],
    services: ["Filter Coffee", "Breakfast Specials", "Sandwiches", "Local Snacks"],
    tags: ["Cosy", "Filter Coffee", "Breakfast", "Takeaway"],
    reviews: [],
  },
  {
    id: "biz-52",
    slug: "karkala-estate-consultants",
    name: "Karkala Estate Consultants",
    tagline: "Trusted property guidance for Karkala and around",
    description:
      "A local real estate consultancy in Karkala helping buyers and sellers with plots, homes, agricultural land and rentals, with transparent advice and complete documentation support.",
    categorySlug: "real-estate",
    subcategory: "Property Consultants",
    districtSlug: "udupi",
    locationSlug: "karkala",
    address: "College Road, Karkala, Udupi District - 574104",
    phone: "+91 8258 230 330",
    whatsapp: "+91 99803 30330",
    email: "info@karkalaestates.in",
    website: "https://karkalaestates.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Karkala%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20real%20estate%20office%20interior%20with%20property%20display%20boards%2C%20clean%20desk%20and%20bright%20daylight%2C%20professional%20consultancy%20photography&width=1200&height=800&seq=cbc-biz-karkala-estates-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 88,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 10,
    hours: [
      { day: "Monday", open: "09:30", close: "18:30", closed: false },
      { day: "Tuesday", open: "09:30", close: "18:30", closed: false },
      { day: "Wednesday", open: "09:30", close: "18:30", closed: false },
      { day: "Thursday", open: "09:30", close: "18:30", closed: false },
      { day: "Friday", open: "09:30", close: "18:30", closed: false },
      { day: "Saturday", open: "10:00", close: "17:00", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Plots & Land", "Homes", "Rentals", "Documentation Support"],
    tags: ["Transparent Advice", "Local Experts", "Documentation", "Property"],
    reviews: [],
  },
  {
    id: "biz-53",
    slug: "karkala-mobile-zone",
    name: "Karkala Mobile Zone",
    tagline: "Smartphones, accessories and quick repairs",
    description:
      "A friendly mobile store in Karkala offering the latest smartphones, accessories, recharge services and reliable repair work for all major brands.",
    categorySlug: "electronics-mobiles",
    subcategory: "Mobile Stores",
    districtSlug: "udupi",
    locationSlug: "karkala",
    address: "Main Road, Karkala, Udupi District - 574104",
    phone: "+91 8258 232 210",
    whatsapp: "+91 90084 32210",
    email: "sales@karkalamobile.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Karkala%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20mobile%20phone%20store%20with%20smartphones%20displayed%20on%20shelves%20and%20accessories%20under%20bright%20lighting%2C%20technology%20retail%20photography&width=1200&height=800&seq=cbc-biz-karkala-mobile-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 94,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 8,
    hours: [
      { day: "Monday", open: "10:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "10:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "10:00", close: "20:30", closed: false },
      { day: "Thursday", open: "10:00", close: "20:30", closed: false },
      { day: "Friday", open: "10:00", close: "21:00", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:30", close: "19:00", closed: false },
    ],
    services: ["Smartphones", "Accessories", "Recharge", "Repairs"],
    tags: ["Quick Repairs", "Accessories", "All Brands", "Friendly Service"],
    reviews: [],
  },
  {
    id: "biz-54",
    slug: "karwar-sea-shore-restaurant",
    name: "Karwar Sea Shore Restaurant",
    tagline: "Fresh seafood with a view of the bay",
    description:
      "A popular seafood restaurant in Karwar serving fresh fish, prawn specials and coastal thalis, with open-air seating overlooking the bay and friendly service.",
    categorySlug: "restaurants",
    subcategory: "Seafood Restaurants",
    districtSlug: "north-canara",
    locationSlug: "karwar",
    address: "Beach Road, Karwar, Uttara Kannada - 581301",
    phone: "+91 8382 228 800",
    whatsapp: "+91 96324 28800",
    email: "hello@karwarseashore.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Karwar%20Beach%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Coastal%20seafood%20restaurant%20with%20open-air%20seating%20and%20bay%20view%2C%20warm%20evening%20lighting%20and%20traditional%20decor%2C%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-karwar-seashore-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.7,
    reviewCount: 312,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 16,
    hours: [
      { day: "Monday", open: "11:30", close: "22:30", closed: false },
      { day: "Tuesday", open: "11:30", close: "22:30", closed: false },
      { day: "Wednesday", open: "11:30", close: "22:30", closed: false },
      { day: "Thursday", open: "11:30", close: "22:30", closed: false },
      { day: "Friday", open: "11:30", close: "23:00", closed: false },
      { day: "Saturday", open: "11:30", close: "23:00", closed: false },
      { day: "Sunday", open: "11:30", close: "22:30", closed: false },
    ],
    services: ["Fresh Seafood", "Coastal Thali", "Prawn Specials", "Open-Air Dining"],
    tags: ["Sea View", "Fresh Catch", "Coastal Special", "Family Dining"],
    reviews: [],
  },
  {
    id: "biz-55",
    slug: "karwar-coastal-stay",
    name: "Karwar Coastal Stay",
    tagline: "Comfortable beachside rooms in Karwar",
    description:
      "A welcoming beachside hotel in Karwar offering clean sea-facing rooms, an in-house restaurant and easy access to the beach and nearby islands.",
    categorySlug: "hotels",
    subcategory: "Beach Resorts",
    districtSlug: "north-canara",
    locationSlug: "karwar",
    address: "Beach Road, Karwar, Uttara Kannada - 581301",
    phone: "+91 8382 226 700",
    whatsapp: "+91 94489 26700",
    email: "stay@karwarcoastal.in",
    website: "https://karwarcoastalstay.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Karwar%20Beach%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Beachside%20hotel%20with%20sea-facing%20rooms%20and%20open%20terrace%2C%20warm%20sunset%20lighting%20and%20coconut%20palms%2C%20coastal%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-karwar-coastalstay-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 219,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 11,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Sea-Facing Rooms", "In-House Restaurant", "Island Trips", "Parking"],
    tags: ["Beachfront", "Sea View", "In-House Dining", "Family Friendly"],
    reviews: [],
  },
  {
    id: "biz-56",
    slug: "karwar-care-hospital",
    name: "Karwar Care Hospital",
    tagline: "Reliable multispeciality care for North Canara",
    description:
      "A multispeciality hospital in Karwar offering cardiology, orthopaedics, maternity and 24-hour emergency services with modern diagnostics and experienced consultants.",
    categorySlug: "healthcare",
    subcategory: "Multispeciality Hospitals",
    districtSlug: "north-canara",
    locationSlug: "karwar",
    address: "Main Road, Karwar, Uttara Kannada - 581301",
    phone: "+91 8382 226 100",
    whatsapp: "+91 94486 26100",
    email: "care@karwarcarehospital.in",
    website: "https://karwarcarehospital.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Karwar%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20hospital%20building%20exterior%20with%20clean%20glass%20facade%20and%20landscaped%20entrance%20in%20bright%20daylight%2C%20healthcare%20architecture%20photography&width=1200&height=800&seq=cbc-biz-karwar-hospital-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 187,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 15,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["24x7 Emergency", "Cardiology", "Orthopaedics", "Maternity"],
    tags: ["Emergency Care", "Modern Diagnostics", "Insurance", "Pharmacy"],
    reviews: [],
  },
  {
    id: "biz-57",
    slug: "sirsi-naturals-ayurveda",
    name: "Sirsi Naturals Ayurveda",
    tagline: "Authentic Ayurvedic care amid the Western Ghats",
    description:
      "A traditional Ayurvedic centre in Sirsi offering Panchakarma, herbal therapy and rejuvenation packages, using classical formulations prepared from locally sourced herbs.",
    categorySlug: "healthcare",
    subcategory: "Ayurveda & Wellness",
    districtSlug: "north-canara",
    locationSlug: "sirsi",
    address: "Yellapur Road, Sirsi, Uttara Kannada - 581401",
    phone: "+91 8384 226 400",
    whatsapp: "+91 99803 26400",
    email: "care@sirsiayurveda.in",
    website: "https://sirsiayurveda.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Sirsi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20Ayurvedic%20wellness%20centre%20with%20wooden%20therapy%20rooms%2C%20herbal%20decor%20and%20soft%20natural%20light%2C%20serene%20wellness%20interior%20photography&width=1200&height=800&seq=cbc-biz-sirsi-ayurveda-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 142,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 12,
    hours: [
      { day: "Monday", open: "08:00", close: "19:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "19:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "19:00", closed: false },
      { day: "Thursday", open: "08:00", close: "19:00", closed: false },
      { day: "Friday", open: "08:00", close: "19:00", closed: false },
      { day: "Saturday", open: "08:00", close: "18:00", closed: false },
      { day: "Sunday", open: "09:00", close: "13:00", closed: false },
    ],
    services: ["Panchakarma", "Herbal Therapy", "Rejuvenation Packages", "Consultations"],
    tags: ["Classical Ayurveda", "Natural Therapy", "Doctor Guided", "Wellness"],
    reviews: [],
  },
  {
    id: "biz-58",
    slug: "sirsi-spice-market",
    name: "Sirsi Spice Market",
    tagline: "Local spices, honey and forest produce",
    description:
      "A well-known store in Sirsi selling authentic local spices, honey, dry fruits and forest produce, with neatly packed gift hampers and bulk supplies for shops.",
    categorySlug: "supermarkets",
    subcategory: "Provision Stores",
    districtSlug: "north-canara",
    locationSlug: "sirsi",
    address: "Market Road, Sirsi, Uttara Kannada - 581401",
    phone: "+91 8384 224 900",
    whatsapp: "+91 97421 24900",
    email: "orders@sirsispicemarket.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Sirsi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20store%20shelves%20with%20jars%20of%20colourful%20local%20spices%2C%20honey%20and%20dry%20fruits%20under%20warm%20lighting%2C%20inviting%20retail%20photography&width=1200&height=800&seq=cbc-biz-sirsi-spicemarket-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 96,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 21,
    hours: [
      { day: "Monday", open: "08:30", close: "20:30", closed: false },
      { day: "Tuesday", open: "08:30", close: "20:30", closed: false },
      { day: "Wednesday", open: "08:30", close: "20:30", closed: false },
      { day: "Thursday", open: "08:30", close: "20:30", closed: false },
      { day: "Friday", open: "08:30", close: "20:30", closed: false },
      { day: "Saturday", open: "08:30", close: "21:00", closed: false },
      { day: "Sunday", open: "09:00", close: "14:00", closed: false },
    ],
    services: ["Local Spices", "Honey & Dry Fruits", "Forest Produce", "Gift Hampers"],
    tags: ["Local Produce", "Gift Hampers", "Bulk Supply", "Trusted"],
    reviews: [],
  },
  {
    id: "biz-59",
    slug: "sirsi-green-homestay",
    name: "Sirsi Green Homestay",
    tagline: "A green retreat near Sirsi's waterfalls",
    description:
      "A peaceful homestay in Sirsi surrounded by greenery, offering comfortable rooms, home-cooked Malnad meals and guided trips to nearby waterfalls and temples.",
    categorySlug: "hotels",
    subcategory: "Homestays",
    districtSlug: "north-canara",
    locationSlug: "sirsi",
    address: "Jog Road, Sirsi, Uttara Kannada - 581401",
    phone: "+91 8384 227 880",
    whatsapp: "+91 97398 27880",
    email: "stay@sirsigreenhomestay.in",
    website: "https://sirsigreenhomestay.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Sirsi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20homestay%20surrounded%20by%20lush%20greenery%20with%20a%20garden%20and%20warm%20evening%20lighting%20in%20the%20Malnad%20region%2C%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-sirsi-homestay-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 108,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 7,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Comfortable Rooms", "Malnad Home Food", "Waterfall Trips", "Guided Tours"],
    tags: ["Nature Retreat", "Home Food", "Guided Trips", "Peaceful"],
    reviews: [],
  },
  {
    id: "biz-60",
    slug: "bhatkal-sea-foods",
    name: "Bhatkal Sea Foods",
    tagline: "Fresh catch, cooked the coastal way",
    description:
      "A lively seafood restaurant in Bhatkal serving fresh fish, prawn fry and traditional coastal curries with quick service and generous portions.",
    categorySlug: "restaurants",
    subcategory: "Seafood Restaurants",
    districtSlug: "north-canara",
    locationSlug: "bhatkal",
    address: "Harbour Road, Bhatkal, Uttara Kannada - 581320",
    phone: "+91 8385 225 300",
    whatsapp: "+91 96322 25300",
    email: "hello@bhatkalseafoods.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Bhatkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Coastal%20seafood%20restaurant%20plate%20of%20fried%20fish%20and%20prawn%20curry%20on%20banana%20leaf%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-bhatkal-seafoods-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 168,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 13,
    hours: [
      { day: "Monday", open: "11:30", close: "22:00", closed: false },
      { day: "Tuesday", open: "11:30", close: "22:00", closed: false },
      { day: "Wednesday", open: "11:30", close: "22:00", closed: false },
      { day: "Thursday", open: "11:30", close: "22:00", closed: false },
      { day: "Friday", open: "11:30", close: "22:30", closed: false },
      { day: "Saturday", open: "11:30", close: "22:30", closed: false },
      { day: "Sunday", open: "11:30", close: "22:00", closed: false },
    ],
    services: ["Fresh Seafood", "Coastal Curries", "Fried Fish", "Takeaway"],
    tags: ["Fresh Catch", "Quick Service", "Coastal Special", "Family Dining"],
    reviews: [],
  },
  {
    id: "biz-61",
    slug: "bhatkal-fashion-mall",
    name: "Bhatkal Fashion Mall",
    tagline: "Everyday fashion for the whole family",
    description:
      "A bright family fashion store in Bhatkal stocking menswear, womenswear, kids' clothing and ethnic wear, with seasonal collections and in-store alterations.",
    categorySlug: "retail",
    subcategory: "Fashion & Apparel",
    districtSlug: "north-canara",
    locationSlug: "bhatkal",
    address: "Main Road, Bhatkal, Uttara Kannada - 581320",
    phone: "+91 8385 226 440",
    whatsapp: "+91 90081 26440",
    email: "care@bhatkalfashion.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Bhatkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20contemporary%20clothing%20store%20interior%20with%20neatly%20displayed%20apparel%20racks%20and%20warm%20lighting%2C%20welcoming%20retail%20photography&width=1200&height=800&seq=cbc-biz-bhatkal-fashion-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.2,
    reviewCount: 82,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 6,
    hours: [
      { day: "Monday", open: "09:30", close: "21:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "21:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "21:00", closed: false },
      { day: "Thursday", open: "09:30", close: "21:00", closed: false },
      { day: "Friday", open: "09:30", close: "21:30", closed: false },
      { day: "Saturday", open: "09:30", close: "21:30", closed: false },
      { day: "Sunday", open: "10:00", close: "20:30", closed: false },
    ],
    services: ["Menswear", "Womenswear", "Kids Wear", "Alterations"],
    tags: ["Family Store", "Seasonal Collections", "Alterations", "Fair Prices"],
    reviews: [],
  },
  {
    id: "biz-62",
    slug: "bhatkal-coastal-clinic",
    name: "Bhatkal Coastal Clinic",
    tagline: "Everyday healthcare for Bhatkal families",
    description:
      "A neighbourhood clinic in Bhatkal offering general medicine, paediatrics, minor procedures and preventive health checkups with caring, experienced doctors.",
    categorySlug: "healthcare",
    subcategory: "Multispeciality Clinics",
    districtSlug: "north-canara",
    locationSlug: "bhatkal",
    address: "Hospital Road, Bhatkal, Uttara Kannada - 581320",
    phone: "+91 8385 226 880",
    whatsapp: "+91 90088 26880",
    email: "care@bhatkalclinic.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Bhatkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20clinic%20consultation%20room%20with%20comfortable%20seating%20and%20bright%20natural%20light%2C%20professional%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-bhatkal-clinic-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.3,
    reviewCount: 76,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 9,
    hours: [
      { day: "Monday", open: "09:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:00", close: "20:00", closed: false },
      { day: "Thursday", open: "09:00", close: "20:00", closed: false },
      { day: "Friday", open: "09:00", close: "20:00", closed: false },
      { day: "Saturday", open: "09:00", close: "18:00", closed: false },
      { day: "Sunday", open: "09:00", close: "13:00", closed: false },
    ],
    services: ["General Medicine", "Paediatrics", "Minor Procedures", "Health Checkups"],
    tags: ["Family Clinic", "Walk-In", "Experienced Doctors", "Preventive Care"],
    reviews: [],
  },
  {
    id: "biz-63",
    slug: "ankola-beach-cafe",
    name: "Ankola Beach Cafe",
    tagline: "Coffee and coastal bites by the Ankola shore",
    description:
      "A relaxed beachside cafe in Ankola serving fresh coffee, burgers, sandwiches and coastal snacks, with casual seating and sea views for a lazy afternoon.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "north-canara",
    locationSlug: "ankola",
    address: "Beach Road, Ankola, Uttara Kannada - 581314",
    phone: "+91 8388 230 770",
    whatsapp: "+91 96864 30770",
    email: "hello@ankolabeachcafe.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Ankola%20Beach%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Relaxed%20beachside%20cafe%20with%20casual%20seating%2C%20string%20lights%20and%20sea%20view%20at%20golden%20hour%2C%20inviting%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-ankola-beachcafe-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 118,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 4,
    hours: [
      { day: "Monday", open: "08:00", close: "22:30", closed: false },
      { day: "Tuesday", open: "08:00", close: "22:30", closed: false },
      { day: "Wednesday", open: "08:00", close: "22:30", closed: false },
      { day: "Thursday", open: "08:00", close: "22:30", closed: false },
      { day: "Friday", open: "08:00", close: "23:00", closed: false },
      { day: "Saturday", open: "08:00", close: "23:00", closed: false },
      { day: "Sunday", open: "08:00", close: "22:30", closed: false },
    ],
    services: ["Coffee & Brews", "Burgers & Sandwiches", "Coastal Snacks", "Sea-Facing Seating"],
    tags: ["Sea View", "Casual", "Wi-Fi", "Takeaway"],
    reviews: [],
  },
  {
    id: "biz-64",
    slug: "ankola-honey-and-spice-store",
    name: "Ankola Honey & Spice Store",
    tagline: "Pure honey, spices and local provisions",
    description:
      "A friendly store in Ankola selling pure wild honey, authentic local spices, dry fruits and daily provisions, with neatly packed gift hampers and bulk supply.",
    categorySlug: "supermarkets",
    subcategory: "Provision Stores",
    districtSlug: "north-canara",
    locationSlug: "ankola",
    address: "Main Bazaar, Ankola, Uttara Kannada - 581314",
    phone: "+91 8388 231 220",
    whatsapp: "+91 90089 31220",
    email: "orders@ankolahoney.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Ankola%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20store%20shelves%20with%20jars%20of%20golden%20honey%2C%20colourful%20spices%20and%20dry%20fruits%20under%20warm%20lighting%2C%20inviting%20retail%20photography&width=1200&height=800&seq=cbc-biz-ankola-honey-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 84,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 10,
    hours: [
      { day: "Monday", open: "08:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "08:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "08:00", close: "20:30", closed: false },
      { day: "Thursday", open: "08:00", close: "20:30", closed: false },
      { day: "Friday", open: "08:00", close: "20:30", closed: false },
      { day: "Saturday", open: "08:00", close: "21:00", closed: false },
      { day: "Sunday", open: "09:00", close: "14:00", closed: false },
    ],
    services: ["Wild Honey", "Local Spices", "Dry Fruits", "Daily Provisions"],
    tags: ["Pure Honey", "Local Spices", "Gift Hampers", "Bulk Supply"],
    reviews: [],
  },
  {
    id: "biz-65",
    slug: "coastal-wave-media",
    name: "Coastal Wave Media",
    tagline: "Radio, video and live event coverage for the coast",
    description:
      "A full-service media house in Mangaluru producing local radio shows, video content, live event coverage and digital campaigns, with an in-house production studio and a young creative team.",
    categorySlug: "media-entertainment",
    subcategory: "TV & Radio Stations",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Kadri Road, Mangaluru, Dakshina Kannada - 575002",
    phone: "+91 824 244 7700",
    whatsapp: "+91 98860 67700",
    email: "hello@coastalwavemedia.in",
    website: "https://coastalwavemedia.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Kadri%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20broadcast%20studio%20interior%20with%20microphone%2C%20acoustic%20panels%20and%20warm%20studio%20lighting%2C%20creative%20media%20production%20photography&width=1200&height=800&seq=cbc-biz-coastal-wave-media-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.5,
    reviewCount: 96,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 7,
    hours: [
      { day: "Monday", open: "09:30", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "20:00", closed: false },
      { day: "Thursday", open: "09:30", close: "20:00", closed: false },
      { day: "Friday", open: "09:30", close: "21:00", closed: false },
      { day: "Saturday", open: "10:00", close: "21:00", closed: false },
      { day: "Sunday", open: "10:00", close: "14:00", closed: false },
    ],
    services: ["Radio Production", "Video Production", "Live Event Coverage", "Digital Campaigns"],
    tags: ["Creative Studio", "Live Streaming", "Video Production", "Branding"],
    reviews: [],
  },
  {
    id: "biz-66",
    slug: "mangaluru-techsail-solutions",
    name: "Mangaluru TechSail Solutions",
    tagline: "Software, websites and IT support for growing businesses",
    description:
      "An information technology company in Mangaluru building custom software, business websites, mobile apps and cloud solutions, with reliable support and annual maintenance contracts for SMEs.",
    categorySlug: "information-technology",
    subcategory: "Software Development",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Balmatta Road, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 5522",
    whatsapp: "+91 94488 45522",
    email: "hello@techsail.in",
    website: "https://techsail.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Balmatta%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20software%20development%20office%20with%20multiple%20monitors%20showing%20code%2C%20bright%20clean%20workspace%20and%20soft%20natural%20light%2C%20professional%20technology%20photography&width=1200&height=800&seq=cbc-biz-techsail-solutions-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.6,
    reviewCount: 118,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 9,
    hours: [
      { day: "Monday", open: "09:00", close: "19:00", closed: false },
      { day: "Tuesday", open: "09:00", close: "19:00", closed: false },
      { day: "Wednesday", open: "09:00", close: "19:00", closed: false },
      { day: "Thursday", open: "09:00", close: "19:00", closed: false },
      { day: "Friday", open: "09:00", close: "19:00", closed: false },
      { day: "Saturday", open: "10:00", close: "14:00", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Custom Software", "Website Development", "Mobile Apps", "IT Support & AMC"],
    tags: ["Software Development", "Cloud Solutions", "AMC Support", "Web & Mobile"],
    reviews: [],
  },
  {
    id: "biz-67",
    slug: "udupi-fine-print-press",
    name: "Udupi Fine Print Press",
    tagline: "Offset, digital and packaging printing under one roof",
    description:
      "A modern printing and publishing house in Udupi offering offset and digital printing, packaging, brochures, wedding cards and book publishing, with quick turnaround and doorstep delivery.",
    categorySlug: "printing-publishing",
    subcategory: "Offset & Digital Printing",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Industrial Area, Udupi, Udupi District - 576103",
    phone: "+91 820 252 4490",
    whatsapp: "+91 97314 24490",
    email: "orders@fineprintudupi.in",
    website: "https://fineprintudupi.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Udupi%20Industrial%20Area%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20printing%20press%20with%20offset%20machine%20and%20stacks%20of%20freshly%20printed%20colourful%20paper%2C%20bright%20industrial%20lighting%2C%20professional%20print%20production%20photography&width=1200&height=800&seq=cbc-biz-udupi-fineprint-press-cover-01&orientation=landscape",
    gallery: [],
    rating: 4.4,
    reviewCount: 87,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 16,
    hours: [
      { day: "Monday", open: "09:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:00", close: "20:00", closed: false },
      { day: "Thursday", open: "09:00", close: "20:00", closed: false },
      { day: "Friday", open: "09:00", close: "20:00", closed: false },
      { day: "Saturday", open: "09:00", close: "20:30", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Offset Printing", "Digital Printing", "Packaging", "Book Publishing"],
    tags: ["Quick Turnaround", "Bulk Printing", "Packaging", "Doorstep Delivery"],
    reviews: [],
  },
];